import React, { useContext, useEffect, useState } from "react";
import OdooStyle from "../../../../assets/css/components/admin/plugins/OdooStyle.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { GlobalContext } from "../../../../contexts/GlobalContext";
import { Link } from "react-router-dom";
import { Form, Row, InputGroup, Container } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import ReactSelect from "react-select";
import verifyAccessRole from "../../../../assets/js/verifyAccessRole";
import PedidosYaStyle from "../../../../assets/css/components/admin/plugins/PedidosYaStyle";
import Routes from "../../../../Routes";
import { BiHide, BiShow } from "react-icons/bi";
import {
  uploadProducts,
  bulkUpdateProducts,
  addMerchantsName,
  syncMerchantsName,
  deleteMerchantsName,
  downloadCategory,
  getMerchantKey,
  testCasheaOrderEndpoint,
  refreshCasheaMerchantToken,
  getCasheaPluginConfig,
  saveCasheaPluginConfig,
  getCasheaAccountConfig,
  saveCasheaAccountConfig,
  fetchCasheaMerchants,
  fetchCasheaMerchantByName,
} from "../../../../hooks/api/cashea";
import { handleUXError } from "../../../../utils";
import {
  keyAccessToken,
  keyUserId,
} from "../../../../assets/js/SessionStorageNames";
import axios from "axios";
import handleAxiosError from "../../update-and-publish/functions/handleAxiosError";
import GetMerchants from "./getMerchants";

const formatApiField = (value) => {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  return JSON.stringify(value);
};

const ui = {
  topBar: {
    background: "#fff",
    border: "1px solid #e7eaf3",
    borderRadius: 14,
    padding: "12px 18px",
    boxShadow: "0 8px 22px rgba(31, 41, 55, 0.06)",
    marginTop: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
  },
  leftCluster: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    flex: "1 1 280px",
    minWidth: 0,
  },
  backBtn: (isHovered) => ({
    width: 42,
    height: 42,
    borderRadius: 12,
    border: "1px solid #e2e8f6",
    background: isHovered ? "#7367f0" : "#f8faff",
    color: isHovered ? "#ffffff" : "#142032",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
    transition: "background 0.2s ease, color 0.2s ease",
  }),
  segmented: {
    display: "inline-flex",
    background: "#eef3fb",
    border: "1px solid #dce6f5",
    borderRadius: 12,
    padding: 4,
    gap: 4,
    flex: "1 1 auto",
    minWidth: 0,
    maxWidth: "450px",
  },
  segBtn: (active, disabled) => ({
    flex: "1 1 0",
    minWidth: 0,
    border: "none",
    borderRadius: 9,
    padding: "10px 14px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.55 : 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    background: active ? "#7367f0" : "transparent",
    color: active ? "#ffffff" : "#334155",
    boxShadow: active ? "0 4px 14px rgba(115, 103, 240, 0.35)" : "none",
    transition: "background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease",
  }),
  accountHint: {
    fontSize: "12px",
    textAlign: "center",
    fontWeight: 600,
    color: "#64748b",
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    marginBottom: 4,
  },
  rightCluster: {
    display: "flex",
    alignItems: "stretch",
    gap: 10,
    flexShrink: 0,
  },
  selectWrap: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minWidth: 200,
  },
  emptyAccounts: {
    fontSize: "14px",
    color: "#64748b",
    padding: "10px 0",
  },
  pageWrap: {
    marginTop: 10,
    padding: "8px 0 24px",
    fontFamily: "sans-serif",
  },
  card: {
    marginTop: 18,
    borderRadius: 16,
    boxShadow: "0 10px 30px rgba(26, 33, 52, 0.08)",
    border: "1px solid #e7eaf3",
    overflow: "hidden",
    background: "#ffffff",
  },
  header: {
    background: "#1465BB",
    borderBottom: "1px solid #e7eaf3",
    padding: "14px 18px",
  },
  headerSub: {
    color: "rgba(255,255,255,0.9)",
    margin: "7px 0 0",
    fontSize: 14,
    fontFamily: "sans-serif",
  },
  body: {
    padding: "20px 22px 24px",
  },
  sectionCard: {
    border: "1px solid #e7eaf3",
    borderRadius: 14,
    padding: 18,
    marginBottom: 18,
    background: "#ffffff",
    boxShadow: "0 8px 18px rgba(20, 32, 50, 0.06)",
  },
  sectionTitle: {
    margin: "0 0 8px",
    color: "#142032",
    fontWeight: 700,
    fontSize: 18,
  },
  sectionDesc: {
    margin: "0 0 14px",
    color: "#5d677c",
    fontSize: 13,
    lineHeight: 1.45,
    textAlign: "center",
  },
  fieldLabel: {
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    fontSize: "11px",
    fontWeight: 700,
    color: "#5b6780",
    marginBottom: 6,
    display: "block",
  },
  input: {
    borderRadius: 10,
    border: "1px solid #b5c0d4",
    background: "#f8faff",
    minHeight: 42,
    width: "100%",
  },
  primaryBtn: {
    borderRadius: 10,
    minHeight: 44,
    border: "none",
    background: "#1465BB",
    color: "#ffffff",
    fontWeight: 600,
    boxShadow: "0 8px 20px rgba(20, 101, 187, 0.25)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  dangerBtn: {
    borderRadius: 10,
    minHeight: 44,
    border: "none",
    background: "#ca0b0b",
    color: "#ffffff",
    fontWeight: 600,
    boxShadow: "0 8px 20px rgba(202, 11, 11, 0.2)",
  },
  opsWrap: {
    marginTop: 36,
    borderRadius: 18,
    border: "1px solid #e7eaf3",
    overflow: "hidden",
    background: "#ffffff",
    boxShadow: "0 14px 34px rgba(20, 32, 50, 0.08)",
  },
  opsHeader: {
    background: "#1465BB",
    padding: "16px 22px",
    borderBottom: "1px solid #dce6f5",
  },
  opsHeaderTitle: {
    color: "#ffffff",
    fontWeight: 700,
    letterSpacing: "0.02em",
    margin: 0,
    fontSize: "18px",
    fontFamily: "sans-serif",
  },
  opsHeaderSub: {
    color: "rgba(255,255,255,0.9)",
    margin: "7px 0 0",
    fontSize: 14,
    fontFamily: "sans-serif",
  },
  opsBody: {
    padding: "24px 22px 28px",
    background: "linear-gradient(180deg, #f8faff 0%, #ffffff 100%)",
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  opsSectionGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: 16,
  },
  actionCard: {
    border: "1px solid #e7eaf3",
    borderRadius: 14,
    background: "#ffffff",
    padding: "22px 16px",
    boxShadow: "0 8px 18px rgba(20, 32, 50, 0.06)",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    fontFamily: "sans-serif",
  },
  actionTitle: {
    margin: 0,
    color: "#142032",
    fontWeight: 700,
    fontSize: "14px",
    textAlign: "center",
  },
  actionDesc: {
    margin: 0,
    color: "#5d677c",
    fontSize: 14,
    lineHeight: 1.45,
    textAlign: "center",
  },
  actionBtn: {
    width: "100%",
    borderRadius: 10,
    minHeight: 50,
    border: "none",
    background: "#1465BB",
    color: "#ffffff",
    fontWeight: 600,
    boxShadow: "0 10px 20px rgba(20, 101, 187, 0.2)",
    fontFamily: "sans-serif",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  secondaryActionBtn: {
    width: "100%",
    borderRadius: 10,
    minHeight: 44,
    border: "none",
    background: "#006A4E",
    color: "#ffffff",
    fontWeight: 600,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
};

const searchSelectStyles = {
  container: (base) => ({ ...base, width: "100%" }),
  control: (base, state) => ({
    ...base,
    width: "100%",
    borderRadius: 10,
    borderColor: state.isFocused ? "#142032" : "#b5c0d4",
    boxShadow: state.isFocused ? "0 0 0 1px #142032" : "none",
    minHeight: 42,
    backgroundColor: "#f8faff",
    "&:hover": { borderColor: "#142032" },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 10px" }),
  indicatorsContainer: (base) => ({ ...base, minHeight: 42 }),
  placeholder: (provided) => ({ ...provided, color: "#8f8aa6" }),
  menu: (base) => ({ ...base, zIndex: 30 }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#142032" : state.isFocused ? "#f2f5fb" : "#fff",
    color: state.isSelected ? "#fff" : "#142032",
  }),
};

export default function CasheaConfig() {
  const globalContext = useContext(GlobalContext);

  const [redirect, setRedirect] = useState(null);
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [backBtnHovered, setBackBtnHovered] = useState(false);
  const [testingEndpoint, setTestingEndpoint] = useState('');
  const [testOrderUuid, setTestOrderUuid] = useState('');
  const [productId, setProductId] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [merchantName, setMerchantName] = useState("");
  const [credentialsMerchantName, setCredentialsMerchantName] = useState("");
  const [tokenMerchantName, setTokenMerchantName] = useState("");
  const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
  const [tarifas, setTarifas] = useState([]);
  const [tarifa, setTarifa] = useState("");
  const [listMerchantName, setListMerchantName] = useState([]);
  const [showPass, setShowPass] = useState(false);
  const defaultMerchantWebConfig = {
    storeId: '',
    merchantId: '',
    merchantGroupId: '',
    employeeRole: 'ADMIN',
    tokenRefresh: '',
    firebaseApiKey: '',
    firebaseRefreshToken: '',
    priceStockEnabled: false,
    ordersEnabled: false,
  };
  const [merchantWebConfig, setMerchantWebConfig] = useState(defaultMerchantWebConfig);
  const [originalMerchantWebConfig, setOriginalMerchantWebConfig] = useState(defaultMerchantWebConfig);
  const [tokenConfig, setTokenConfig] = useState({
    tokenRefresh: '',
    tokenUpdatedAt: '',
  });
  const defaultEnterpriseCasheaConfig = {
    odooJournalId: '',
    paymentMethodId: '1',
    paymentTerm: '',
    urlBase: '',
    firebaseSecureTokenBaseUrl: '',
    merchantWebOrdersBaseUrl: '',
    orderDetailsBaseUrl: '',
    orderInstallmentsBaseUrl: '',
    casheaAutomation: false,
    batchCreateEnabled: false,
    batchBillingEnabled: false,
    asyncQueueEnabled: false,
    batchMaxOrdersPerCall: '200',
    batchMaxPaymentsPerCall: '200',
    batchReconcileSleepMs: '250',
    batchConsumerBatchSize: '50',
    batchStaleProcessingMinutes: '20',
    batchMaxAttempts: '5',
  };
  const [enterpriseCasheaConfig, setEnterpriseCasheaConfig] = useState(defaultEnterpriseCasheaConfig);
  const [savingEnterpriseConfig, setSavingEnterpriseConfig] = useState(false);
  const [savingCasheaAutomation, setSavingCasheaAutomation] = useState(false);
  const [savingBatchConfig, setSavingBatchConfig] = useState(false);
  const [urlFieldErrors, setUrlFieldErrors] = useState({
    firebaseSecureTokenBaseUrl: '',
    orderDetailsBaseUrl: '',
    orderInstallmentsBaseUrl: '',
    urlBase: '',
    merchantWebOrdersBaseUrl: '',
  });
  const hasMerchants = listMerchantName.length > 0;
  const merchantCredentialInputsDisabled = loading || !hasMerchants || !credentialsMerchantName;
  const tarifaOptions = tarifas.map((val) => ({
    value: val.name,
    label: val.name,
  }));
  const selectedTarifaOption = tarifaOptions.find((option) => option.value === tarifa) || null;
  const fieldStyle = ui.input;

  /**
   * This object indicates the type of synchronization.
   */
  const syncMerchantConfig = {
    merchantAdd: "",
    merchantsAddAll: Boolean,
  };
  
  // config
  const [syncMerchant, updateSyncMerchant] = useState(syncMerchantConfig);

  /**
   * Change rate
   */
  function changeTarifa(value) {
    console.log(`Tarifa seleccionada: ${value}`)
    localStorage.setItem(tarifa, value)
    setTarifa(value)
  }

  /**
   * Change marchantName
   */
  function changeMerchantName(e){
    setMerchantName(e.target.value)
    console.log(e.target.value)
  }

  function changeCredentialsMerchantName(e){
    setCredentialsMerchantName(e.target.value)
  }

  function updateMerchantWebConfig(e) {
    setMerchantWebConfig({
      ...merchantWebConfig,
      [e.target.name]: e.target.value,
    });

    if (e.target.name === 'tokenRefresh' && credentialsMerchantName === tokenMerchantName) {
      setTokenConfig({
        ...tokenConfig,
        tokenRefresh: e.target.value,
      });
    }
  }

  const urlFieldLabels = {
    firebaseSecureTokenBaseUrl: 'URL refresh token ',
    orderDetailsBaseUrl: 'URL detalle de ordenes (Merchant Web)',
    orderInstallmentsBaseUrl: 'URL cuotas / referencia de pago (Merchant Web)',
    urlBase: 'URL base principal Cashea (urlBase)',
    merchantWebOrdersBaseUrl: 'URL listado de ordenes (Merchant Web)',
  };

  const requiredGlobalFieldLabels = {
    urlBase: 'URL base principal Cashea (urlBase)',
    merchantWebOrdersBaseUrl: 'URL listado de ordenes (Merchant Web)',
    orderDetailsBaseUrl: 'URL detalle de ordenes (Merchant Web)',
    firebaseSecureTokenBaseUrl: 'URL refresh token ',
    paymentMethodId: 'Método de pago Odoo (paymentMethodId)',
  };

  const validateHttpsUrl = (value) => {
    const trimmed = String(value || '').trim();
    if (!trimmed) return '';
    try {
      const parsed = new URL(trimmed);
      if (parsed.protocol !== 'https:') return 'Debe usar HTTPS (https://)';
      if (!parsed.hostname) return 'Debe incluir un dominio válido';
      return '';
    } catch (_) {
      return 'Debe tener formato de URL válida (ej: https://dominio.com/ruta)';
    }
  };

  const validateConfiguredUrlFields = (source) => {
    const nextErrors = {
      firebaseSecureTokenBaseUrl: validateHttpsUrl(source.firebaseSecureTokenBaseUrl),
      orderDetailsBaseUrl: validateHttpsUrl(source.orderDetailsBaseUrl),
      orderInstallmentsBaseUrl: validateHttpsUrl(source.orderInstallmentsBaseUrl),
      urlBase: validateHttpsUrl(source.urlBase),
      merchantWebOrdersBaseUrl: validateHttpsUrl(source.merchantWebOrdersBaseUrl),
    };
    setUrlFieldErrors(nextErrors);
    return nextErrors;
  };

  const hasUrlValidationErrors = (errors) => (
    Object.values(errors).some((message) => Boolean(message))
  );

  const getMissingRequiredGlobalFields = () => (
    Object.keys(requiredGlobalFieldLabels).filter((field) => {
      const value = enterpriseCasheaConfig[field];
      return String(value ?? '').trim() === '';
    })
  );

  function getMerchantWebChangedPayload() {
    const payload = {};
    const numericFields = ['storeId', 'merchantId', 'merchantGroupId'];

    Object.keys(merchantWebConfig).forEach((field) => {
      const currentValue = merchantWebConfig[field] ?? '';
      const originalValue = originalMerchantWebConfig[field] ?? '';

      if (String(currentValue) === String(originalValue)) return;

      payload[field] = numericFields.includes(field)
        ? (currentValue ? Number(currentValue) : null)
        : currentValue;
    });

    return payload;
  }

  // Las URLs ya NO se cargan desde el merchant: son globales por empresa (config.cashea.urls) y se
  // cargan en loadCasheaEnterpriseConfig. Aquí solo se sincronizan las credenciales del merchant.
  const syncMerchantFieldsToForms = (merchant) => {
    if (!merchant?.name) return;
    const merchantFields = {
      storeId: merchant.storeId ?? '',
      merchantId: merchant.merchantId ?? '',
      merchantGroupId: merchant.merchantGroupId ?? '',
      employeeRole: merchant.employeeRole || 'ADMIN',
      tokenRefresh: merchant.tokenRefresh || '',
      firebaseApiKey: merchant.firebaseApiKey || '',
      firebaseRefreshToken: merchant.firebaseRefreshToken || '',
      priceStockEnabled: Boolean(merchant.priceStockEnabled),
      ordersEnabled: Boolean(merchant.ordersEnabled),
    };
    setMerchantWebConfig(merchantFields);
    setOriginalMerchantWebConfig(merchantFields);
  };

  const loadGlobalMerchantConfig = async (entId, merchantName) => {
    if (!entId || !merchantName) return null;
    try {
      const merchant = await fetchCasheaMerchantByName({ enterpriseId: entId, name: merchantName });
      if (merchant?.name) syncMerchantFieldsToForms(merchant);
      return merchant;
    } catch (err) {
      console.error('[Cashea] Error cargando config del merchant:', err);
      return null;
    }
  };

  const resolveMerchantNameForUrls = (merchants = listMerchantName) => (
    merchants[0]?.name || ''
  );

  const loadCasheaEnterpriseConfig = async (entId) => {
    if (!entId) {
      setEnterpriseCasheaConfig(defaultEnterpriseCasheaConfig);
      return;
    }

    try {
      const configData = await getCasheaPluginConfig(entId);
      const accountData = await getCasheaAccountConfig(entId);
      const merchants = await fetchCasheaMerchants({ enterpriseId: entId });
      const merchantName = resolveMerchantNameForUrls(merchants);

      setEnterpriseCasheaConfig((prev) => ({
        ...prev,
        odooJournalId: configData.odooJournalId != null && configData.odooJournalId !== ''
          ? String(configData.odooJournalId)
          : '',
        paymentMethodId: configData.paymentMethodId != null && configData.paymentMethodId !== ''
          ? String(configData.paymentMethodId)
          : '1',
        casheaAutomation: Boolean(accountData.casheaAutomation),
        paymentTerm: accountData.paymentTerm != null && accountData.paymentTerm !== ''
          ? String(accountData.paymentTerm)
          : '',
        batchCreateEnabled: Boolean(configData.batchCreateEnabled),
        batchBillingEnabled: Boolean(configData.batchBillingEnabled),
        asyncQueueEnabled: Boolean(configData.asyncQueueEnabled),
        batchMaxOrdersPerCall: String(configData.batch?.maxOrdersPerCall ?? 200),
        batchMaxPaymentsPerCall: String(configData.batch?.maxPaymentsPerCall ?? 200),
        batchReconcileSleepMs: String(configData.batch?.reconcileSleepMs ?? 250),
        batchConsumerBatchSize: String(configData.batch?.consumerBatchSize ?? 50),
        batchStaleProcessingMinutes: String(configData.batch?.staleProcessingMinutes ?? 20),
        batchMaxAttempts: String(configData.batch?.maxAttempts ?? 5),
        // URLs globales por empresa: se leen de config.cashea.urls (ya no del merchant).
        // urlBase también es global: prioriza config.cashea.urls; cae a cashea_accounts si aún no migró.
        urlBase: configData.urls?.urlBase || accountData.urlBase || defaultEnterpriseCasheaConfig.urlBase,
        merchantWebOrdersBaseUrl: configData.urls?.merchantWebOrdersBaseUrl || '',
        orderDetailsBaseUrl: configData.urls?.orderDetailsBaseUrl || '',
        orderInstallmentsBaseUrl: configData.urls?.orderInstallmentsBaseUrl || '',
        firebaseSecureTokenBaseUrl: configData.urls?.firebaseSecureTokenBaseUrl || '',
      }));

      // Solo para precargar las credenciales del primer merchant (storeId, tokens, etc.), no URLs.
      if (merchantName) {
        await loadGlobalMerchantConfig(entId, merchantName);
      }
    } catch (err) {
      console.error('[Cashea] Error cargando config enterprise:', err);
      handleAxiosError(err, 'No se pudo cargar la configuración global de Cashea.', true, globalContext);
    }
  };

  const saveCasheaEnterpriseConfig = async () => {
    const entId = globalContext.currentEnterpriseId;
    if (!entId) {
      globalContext.showModalWithMsg('Debe seleccionar una empresa');
      return;
    }

    const journalId = enterpriseCasheaConfig.odooJournalId
      ? Number(enterpriseCasheaConfig.odooJournalId)
      : null;
    const paymentMethodId = enterpriseCasheaConfig.paymentMethodId
      ? Number(enterpriseCasheaConfig.paymentMethodId)
      : 1;

    if (enterpriseCasheaConfig.odooJournalId && !Number.isFinite(journalId)) {
      globalContext.showModalWithMsg('El ID del diario Odoo debe ser un número válido');
      return;
    }

    const paymentTermRaw = String(enterpriseCasheaConfig.paymentTerm ?? '').trim();
    if (paymentTermRaw !== '' && !Number.isFinite(Number(paymentTermRaw))) {
      globalContext.showModalWithMsg('El término de pago debe ser un número válido');
      return;
    }

    const missingRequiredFields = getMissingRequiredGlobalFields();
    if (missingRequiredFields.length) {
      const missingLabels = missingRequiredFields.map((field) => requiredGlobalFieldLabels[field]);
      globalContext.showModalWithMsg(`Todos los campos globales son obligatorios. Faltan:\n- ${missingLabels.join('\n- ')}`);
      return;
    }

    const nextUrlErrors = validateConfiguredUrlFields(enterpriseCasheaConfig);
    if (hasUrlValidationErrors(nextUrlErrors)) {
      const firstInvalidField = Object.keys(nextUrlErrors).find((field) => nextUrlErrors[field]);
      const fieldLabel = urlFieldLabels[firstInvalidField] || 'una URL';
      globalContext.showModalWithMsg(`Corrija el formato de ${fieldLabel} antes de guardar`);
      return;
    }

    setSavingEnterpriseConfig(true);
    try {
      // TODAS las URLs (incluida urlBase) se guardan como objeto global en enterprise.config.cashea.urls.
      // El backend ignora URLs en el payload de merchant.
      await saveCasheaPluginConfig(entId, {
        odooJournalId: journalId,
        paymentMethodId: Number.isFinite(paymentMethodId) ? paymentMethodId : 1,
        urls: {
          urlBase: enterpriseCasheaConfig.urlBase || '',
          merchantWebOrdersBaseUrl: enterpriseCasheaConfig.merchantWebOrdersBaseUrl || '',
          orderDetailsBaseUrl: enterpriseCasheaConfig.orderDetailsBaseUrl || '',
          orderInstallmentsBaseUrl: enterpriseCasheaConfig.orderInstallmentsBaseUrl || '',
          firebaseSecureTokenBaseUrl: enterpriseCasheaConfig.firebaseSecureTokenBaseUrl || '',
        },
      });
      // cashea_accounts solo guarda ya casheaAutomation y paymentTerm (urlBase migró a config.cashea.urls).
      await saveCasheaAccountConfig(entId, {
        casheaAutomation: Boolean(enterpriseCasheaConfig.casheaAutomation),
        paymentTerm: String(enterpriseCasheaConfig.paymentTerm ?? '').trim() === ''
          ? null
          : Number(enterpriseCasheaConfig.paymentTerm),
      });
      await loadCasheaEnterpriseConfig(entId);
      globalContext.showModalWithMsg('Configuración global de Cashea guardada correctamente');
    } catch (err) {
      handleAxiosError(err, 'No se pudo guardar la configuración global de Cashea.', true, globalContext);
    } finally {
      setSavingEnterpriseConfig(false);
    }
  };

  const saveCasheaAutomationConfig = async () => {
    const entId = globalContext.currentEnterpriseId;
    if (!entId) {
      globalContext.showModalWithMsg('Debe seleccionar una empresa');
      return;
    }

    setSavingCasheaAutomation(true);
    try {
      const payload = {
        casheaAutomation: Boolean(enterpriseCasheaConfig.casheaAutomation),
      };
      await saveCasheaAccountConfig(entId, payload);
      await loadCasheaEnterpriseConfig(entId);
      globalContext.showModalWithMsg(
        enterpriseCasheaConfig.casheaAutomation
          ? 'Automatización de Cashea activada'
          : 'Automatización de Cashea desactivada: las órdenes se crearán en borrador',
      );
    } catch (err) {
      handleAxiosError(err, 'No se pudo guardar la automatización de Cashea.', true, globalContext);
    } finally {
      setSavingCasheaAutomation(false);
    }
  };

  const saveCasheaBatchConfig = async () => {
    const entId = globalContext.currentEnterpriseId;
    if (!entId) {
      globalContext.showModalWithMsg('Debe seleccionar una empresa');
      return;
    }

    const batchCreateEnabled = Boolean(enterpriseCasheaConfig.batchCreateEnabled);
    const batchBillingEnabled = Boolean(enterpriseCasheaConfig.batchBillingEnabled);
    const asyncQueueEnabled = Boolean(enterpriseCasheaConfig.asyncQueueEnabled);

    // Regla de dependencia: la facturación en lote se apoya en la creación en lote.
    if (batchBillingEnabled && !batchCreateEnabled) {
      globalContext.showModalWithMsg('La "Facturación en lote" requiere activar primero la "Creación de órdenes en lote".');
      return;
    }

    setSavingBatchConfig(true);
    try {
      // Los parámetros numéricos se coaccionan aquí; el backend los acota a rangos seguros
      // (CASHEA_BATCH_RANGES) — el valor mostrado tras recargar es el efectivo.
      await saveCasheaPluginConfig(entId, {
        batchCreateEnabled,
        batchBillingEnabled,
        asyncQueueEnabled,
        batch: {
          maxOrdersPerCall: Number(enterpriseCasheaConfig.batchMaxOrdersPerCall),
          maxPaymentsPerCall: Number(enterpriseCasheaConfig.batchMaxPaymentsPerCall),
          reconcileSleepMs: Number(enterpriseCasheaConfig.batchReconcileSleepMs),
          consumerBatchSize: Number(enterpriseCasheaConfig.batchConsumerBatchSize),
          staleProcessingMinutes: Number(enterpriseCasheaConfig.batchStaleProcessingMinutes),
          maxAttempts: Number(enterpriseCasheaConfig.batchMaxAttempts),
        },
      });
      await loadCasheaEnterpriseConfig(entId);
      globalContext.showModalWithMsg('Configuración de procesamiento en lotes guardada correctamente');
    } catch (err) {
      handleAxiosError(err, 'No se pudo guardar la configuración de procesamiento en lotes.', true, globalContext);
    } finally {
      setSavingBatchConfig(false);
    }
  };

  const updateEnterpriseCasheaConfig = (e) => {
    const { name, value, type, checked } = e.target;
    const nextValue = type === 'checkbox' ? checked : value;
    setEnterpriseCasheaConfig((prev) => ({
      ...prev,
      [name]: nextValue,
      // La facturación en lote depende de la creación en lote: si se desactiva la
      // creación, se desactiva también la facturación para no dejar un estado inválido.
      ...(name === 'batchCreateEnabled' && !nextValue ? { batchBillingEnabled: false } : {}),
    }));
    if (Object.prototype.hasOwnProperty.call(urlFieldErrors, name)) {
      setUrlFieldErrors((prev) => ({
        ...prev,
        [name]: validateHttpsUrl(value),
      }));
    }
  };

  /**
   * Function to consult the lists of available rates
   */
  async function getPriceList() {
    const entId = await globalContext.currentEnterpriseId;
    const url = `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-pricelist/${entId}`;
    if (entId)
      await axios
        .get(url, {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        })
        .then((resp) => {
          const data = resp.data.data;
          setTarifas(data.priceLists);
        })
        .catch((err) => {
          console.log(err);
          handleAxiosError(
            err,
            "Disculpe, no se pudo cargar la lista de tarifas.",
            true,
            globalContext,
          );
        });
  }

  /**
   * Bulk upload/update products
   * Action: upload/update
   * bulkStatus: indicates to scan all merchants of all merchants
   */
  const handleBulkUploadProducts = async (action, bulkStatus) => {
    let message;
    try {
      let data = {
        enterpriseId: globalContext.currentEnterpriseId,
      };
      console.log('Merchant: data', merchantName)
         data = {
          ...data,
          productAction: action,
          merchantName,
          allMerchants: bulkStatus

         }
      
      const res = await bulkUpdateProducts(data);
      message = res?.message;
      
      globalContext.showModalWithMsg(message)
    } catch (err) {
      handleUXError(err.message, "Disculpe, ha ocurrido un error.");
    } finally {
    }
  }; 

  /**
   * Update products individually
   * Action: Update
   */
  const handleUpdateProduct = async (value) => {
    setLoading(true);
    let message;

    try {
      const data = await uploadProducts({
        productIds: [productId],
        productAction: value,
        enterpriseId: globalContext.currentEnterpriseId,
        merchantName
      });
      message = data?.message;
    } catch (err) {
      handleUXError(err.message, "Disculpe, ha ocurrido un error.");
    } finally {
      setLoading(false);
      await globalContext.showModalWithMsg(message)
    }
  }; 

 
  /**
   * CRUD Merchant
   */
  const handleMerchant = async (action, value) => {
    setLoading(true);
    let data;
    const ent = globalContext.currentEnterpriseId;
    const actionsMap = {
      update: async () => {       //Actualizar merchant
        console.log('tarifa', tarifa)
        data = await addMerchantsName({
          enterpriseId: ent,
          name: value,
          apiKey,
          tarifa,
        });
      },
      updateCredentials: async () => {
        if (!hasMerchants || !value) {
          data = { message: 'Debe seleccionar un merchant para actualizar credenciales' };
          return;
        }

        const changedPayload = getMerchantWebChangedPayload();
        if (!Object.keys(changedPayload).length) {
          data = { message: 'No hay cambios para actualizar' };
          return;
        }

        data = await addMerchantsName({
          enterpriseId: ent,
          name: value,
          ...changedPayload,
        });
        const merchant = await fetchCasheaMerchantByName({ enterpriseId: ent, name: value });
        if (merchant) syncMerchantFieldsToForms(merchant);
      },
      uptTarifa: async () => {    //Actualizar todas las tarifas de todos los merchants
        data = await addMerchantsName({
          enterpriseId: ent,
          tarifa,
          uptTarifa: true,
        });
      },
      sync: async () => {       //Sincroniza los merchants, individual o masivos a travez de merchantsAddAll, si este es igual a false sera individual, si es true es masivo
        data = await syncMerchantsName({
          ...syncMerchant,
          merchantsAddAll: value === 'all',
          enterpriseId: ent,
        });
      },
      delete: async () => {       //Elimina el merchant de la BD
        console.log('delete', value);
        data = await deleteMerchantsName({ name: value });
      },
      'download-categories': async () => {        //Descarga todas las categorias de Cashea
        data = await downloadCategory({ enterpriseId: ent });
      },
    };
    try {

      if (actionsMap[action]) {
        await actionsMap[action]();
      } else {
        throw new Error(`Acción no soportada: ${action}`);
      }
      
    } catch (err) {
      handleUXError(err.message, "Disculpe, ha ocurrido un error.");
      console.log(`${err} error`)
    } finally {
      setLoading(false);
      if(data?.message) await globalContext.showModalWithMsg(data.message);
    }
  };

  const handleTestOrderEndpoint = async (endpoint) => {
    if (!credentialsMerchantName) {
      await globalContext.showModalWithMsg('Seleccione un merchant para probar el endpoint');
      return;
    }

    setTestingEndpoint(endpoint);
    try {
      const response = await testCasheaOrderEndpoint({
        enterpriseId: globalContext.currentEnterpriseId,
        merchantName: credentialsMerchantName,
        endpoint,
        merchantWebOrdersBaseUrl: enterpriseCasheaConfig.merchantWebOrdersBaseUrl || undefined,
        orderDetailsBaseUrl: enterpriseCasheaConfig.orderDetailsBaseUrl || undefined,
        orderInstallmentsBaseUrl: enterpriseCasheaConfig.orderInstallmentsBaseUrl || undefined,
        orderUuid: endpoint === 'payment-reference' ? (testOrderUuid.trim() || undefined) : undefined,
      });
      const data = response?.data || {};
      const requestsMessage = (data.requests || []).map((request) => (
        `${request.success ? 'OK' : 'ERROR'} ${request.name}: status ${request.status || 'N/A'}${request.error ? ` - ${request.error}` : ''}`
      ));
      const message = [
        `${data.success ? 'Endpoint probado correctamente' : 'Endpoint con error'}: ${data.endpoint || endpoint}`,
        `Merchant: ${data.merchantName || credentialsMerchantName}`,
        ...requestsMessage,
        data.error ? `Error: ${data.error}` : null,
        data.total !== undefined ? `Total: ${data.total}` : null,
        data.paidTotal !== undefined ? `Pagadas: ${data.paidTotal}` : null,
        data.firstIdentifierNumber ? `Primera orden: ${data.firstIdentifierNumber}` : null,
        data.firstPaidOrderNumber ? `Primera pagada: ${data.firstPaidOrderNumber}` : null,
        data.orderUuid ? `UUID detalle: ${data.orderUuid}` : null,
        data.productsTotal !== undefined ? `Productos detalle: ${data.productsTotal}` : null,
        data.identifierNumber ? `Orden probada: ${data.identifierNumber}` : null,
        data.url ? `URL: ${data.url}` : null,
        data.installmentsTotal !== undefined ? `Cuotas devueltas: ${data.installmentsTotal}` : null,
        data.reference ? `Referencia de pago: ${data.reference}` : null,
        data.memo ? `Memo que se escribiría en Odoo: ${data.memo}` : null,
        data.firstInstallmentShape ? `Forma de la 1ra cuota: ${JSON.stringify(data.firstInstallmentShape)}` : null,
      ].filter(Boolean).join('\n');

      await globalContext.showModalWithMsg(message);
    } catch (err) {
      handleUXError(err.message, "No se pudo probar el endpoint de Cashea.");
    } finally {
      setTestingEndpoint('');
    }
  };

  const getMerchantTokenConfig = async (e) => {
    e.persist();
    const merchantName = e.target.value;
    setTokenMerchantName(merchantName);
    const entId = await globalContext.currentEnterpriseId;

    try {
      const response = await getMerchantKey({
        name: merchantName,
        enterpriseId: entId,
      });
      const merchant = response.data.data;
      setTokenConfig({
        ...tokenConfig,
        tokenRefresh: merchant.tokenRefresh || '',
        tokenUpdatedAt: merchant.tokenUpdatedAt || '',
      });
    } catch (error) {
      console.error('Error al obtener configuración de token del merchant:', error);
    }
  };

  const handleRefreshMerchantToken = async () => {
    if (!tokenMerchantName) {
      await globalContext.showModalWithMsg('Seleccione un merchant para actualizar el token');
      return;
    }
    setLoading(true);
    try {
      const response = await refreshCasheaMerchantToken({
        enterpriseId: globalContext.currentEnterpriseId,
        name: tokenMerchantName,
      });
      const data = response?.data || {};
      if (!data.success) {
        const message = [
          response?.message || `No se pudo actualizar el token para ${data.merchantName || tokenMerchantName}`,
          data.status ? `Status: ${data.status}` : null,
          data.statusText ? `Status text: ${data.statusText}` : null,
          data.error ? `Error: ${formatApiField(data.error)}` : null,
          data.googleResponse ? `Respuesta Google: ${formatApiField(data.googleResponse)}` : null,
          data.merchantTokenFields ? `Campos token: ${formatApiField(data.merchantTokenFields)}` : null,
        ].filter(Boolean).join('\n');

        await globalContext.showModalWithMsg(message);
        return;
      }
      const merchant = await fetchCasheaMerchantByName({
        name: tokenMerchantName,
        enterpriseId: globalContext.currentEnterpriseId,
      });
      setTokenConfig({
        ...tokenConfig,
        tokenRefresh: merchant?.tokenRefresh || '',
        tokenUpdatedAt: data.tokenUpdatedAt || new Date().toISOString(),
      });
      setCredentialsMerchantName(tokenMerchantName);
      if (merchant) syncMerchantFieldsToForms(merchant);

      await globalContext.showModalWithMsg(
        response?.message || `Token actualizado correctamente para ${data.merchantName || tokenMerchantName}`
      );
    } catch (err) {
      const message = typeof err?.message === 'string' && err.message !== '[object Object]'
        ? err.message
        : 'No se pudo actualizar el token de Cashea.';
      await globalContext.showModalWithMsg(message);
    } finally {
      setLoading(false);
    }
  };

  function changeStep(number) {
    if (step !== 0) setStep(number);
  }



  /**
   * Merchant selected to sync
   */
  const hdlSetSyncMerchants = (e) => {
    console.log(`Merchant seleccionado${e.target.name}`)
    updateSyncMerchant({
      ...syncMerchant,
      [e.target.name]: e.target.value,
    });
    console.log('syncMerchant data: ', syncMerchant)
  };

  const getMerchant = async (e) => {
    e.persist(); // Evita que React libere el evento
    setApiKey('');
    const entId = await globalContext.currentEnterpriseId;
    console.log('ent', entId);
    console.log('se cliqueo');
    try {
      const response = await getMerchantKey({
        name: e.target.value,
        enterpriseId: entId,
      });
      const merchant = await fetchCasheaMerchantByName({
        name: e.target.value,
        enterpriseId: entId,
      });
      setApiKey(merchant?.apiKey || '');
      if (merchant) syncMerchantFieldsToForms(merchant);
    } catch (error) {
      console.error('Error al obtener el merchant key:', error);
    }
  };

  const getMerchantCredentials = async (e) => {
    e.persist();
    changeCredentialsMerchantName(e);
    const entId = await globalContext.currentEnterpriseId;
    try {
      const response = await getMerchantKey({
        name: e.target.value,
        enterpriseId: entId,
      });
      const merchant = await fetchCasheaMerchantByName({
        name: e.target.value,
        enterpriseId: entId,
      });
      if (merchant) syncMerchantFieldsToForms(merchant);
    } catch (error) {
      console.error('Error al obtener las credenciales del merchant:', error);
    }
  };

  useEffect(()=>{
    const getMerchantLists = async () =>{
      const entId = await globalContext.currentEnterpriseId;
      console.log('ent data', entId)
        try {
          const merchants = await fetchCasheaMerchants({ enterpriseId: entId });
          setListMerchantName(merchants);
          if (!merchants.length) {
            setCredentialsMerchantName('');
            setTokenMerchantName('');
            setMerchantWebConfig(defaultMerchantWebConfig);
            setOriginalMerchantWebConfig(defaultMerchantWebConfig);
            setTokenConfig({
              tokenRefresh: '',
              tokenUpdatedAt: '',
            });
          } else {
            await loadCasheaEnterpriseConfig(entId);
          }
        } catch (error) {
          console.log(error)
        }

    }
    getMerchantLists();
  }, [globalContext.currentEnterpriseId]);

  useEffect(() => {
    getPriceList();
  }, [globalContext.currentEnterpriseId]);



const toggleShowPassword = (e) => {
  e.preventDefault();
  setShowPass(!showPass)
}

  const authConfigView = () => {
    return (
      <div style={ui.pageWrap}>
        <PedidosYaStyle.ContForm style={ui.card}>
          <PedidosYaStyle.HeaderForm style={ui.header}>
            <PedidosYaStyle.Text size="14pt" fw="500" cl="#FFFFFF">
              Credenciales de <span style={{ fontWeight: "bold" }}>Cashea</span>
            </PedidosYaStyle.Text>
            <p style={ui.headerSub}>
              Configuración global por empresa. Se carga automáticamente al seleccionar la empresa.
            </p>
          </PedidosYaStyle.HeaderForm>

          <PedidosYaStyle.BodyForm style={ui.body}>
            <div style={ui.sectionCard}>
              <h4 style={ui.sectionTitle}>Configuración global Cashea (empresa)</h4>
              <p style={ui.sectionDesc}>
                Odoo (diario/método) se guarda en <strong>enterprise.config.cashea</strong>. <strong>Todas las URLs</strong> (base principal, Merchant Web y Firebase) son globales por empresa y se guardan en <strong>enterprise.config.cashea.urls</strong>. La automatización y el término de pago se guardan en <strong>cashea_accounts</strong>.
              </p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 12, alignItems: 'end' }}>
                          <Form.Group style={{gridColumn: '1 / -1'}}>
                            <span style={ui.fieldLabel}>URL base principal Cashea (urlBase)</span>
                            <PedidosYaStyle.Input
                              style={fieldStyle}
                              name="urlBase"
                              value={enterpriseCasheaConfig.urlBase}
                              disabled={loading || savingEnterpriseConfig}
                              placeholder=""
                              autoComplete="off"
                              onChange={updateEnterpriseCasheaConfig}
                            />
                            {urlFieldErrors.urlBase && (
                              <small style={{color: '#ca0b0b', display: 'block', marginTop: 6}}>
                                {urlFieldErrors.urlBase}
                              </small>
                            )}
                          </Form.Group>
                          <Form.Group style={{gridColumn: '1 / -1'}}>
                            <PedidosYaStyle.Text size="12pt">URL listado de ordenes (Merchant Web)</PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                              style={fieldStyle}
                              name="merchantWebOrdersBaseUrl"
                              value={enterpriseCasheaConfig.merchantWebOrdersBaseUrl}
                              disabled={loading || savingEnterpriseConfig}
                              placeholder="URL de listado de órdenes"
                              autoComplete="off"
                              onChange={updateEnterpriseCasheaConfig}
                            />
                            {urlFieldErrors.merchantWebOrdersBaseUrl && (
                              <small style={{color: '#ca0b0b', display: 'block', marginTop: 6}}>
                                {urlFieldErrors.merchantWebOrdersBaseUrl}
                              </small>
                            )}
                          </Form.Group>
                          <Form.Group style={{gridColumn: '1 / -1'}}>
                            <PedidosYaStyle.Text size="12pt">URL detalle de ordenes (Merchant Web)</PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                              style={fieldStyle}
                              name="orderDetailsBaseUrl"
                              value={enterpriseCasheaConfig.orderDetailsBaseUrl}
                              disabled={loading || savingEnterpriseConfig}
                              placeholder="URL de detalle por UUID"
                              autoComplete="off"
                              onChange={updateEnterpriseCasheaConfig}
                            />
                            {urlFieldErrors.orderDetailsBaseUrl && (
                              <small style={{color: '#ca0b0b', display: 'block', marginTop: 6}}>
                                {urlFieldErrors.orderDetailsBaseUrl}
                              </small>
                            )}
                          </Form.Group>
                          <Form.Group style={{gridColumn: '1 / -1'}}>
                            <PedidosYaStyle.Text size="12pt">URL cuotas / referencia de pago (Merchant Web)</PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                              style={fieldStyle}
                              name="orderInstallmentsBaseUrl"
                              value={enterpriseCasheaConfig.orderInstallmentsBaseUrl}
                              disabled={loading || savingEnterpriseConfig}
                              placeholder="Opcional. Ej: https://core.api.cashea.app/merchant-web/orders"
                              autoComplete="off"
                              onChange={updateEnterpriseCasheaConfig}
                            />
                            {urlFieldErrors.orderInstallmentsBaseUrl && (
                              <small style={{color: '#ca0b0b', display: 'block', marginTop: 6}}>
                                {urlFieldErrors.orderInstallmentsBaseUrl}
                              </small>
                            )}
                          </Form.Group>
                          <Form.Group style={{gridColumn: '1 / -1'}}>
                            <PedidosYaStyle.Text size="12pt">URL refresh token </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                              style={fieldStyle}
                              name="firebaseSecureTokenBaseUrl"
                              value={enterpriseCasheaConfig.firebaseSecureTokenBaseUrl}
                              disabled={loading || savingEnterpriseConfig}
                              placeholder="URL base de refresh token Firebase"
                              autoComplete="off"
                              onChange={updateEnterpriseCasheaConfig}
                            />
                            {urlFieldErrors.firebaseSecureTokenBaseUrl && (
                              <small style={{color: '#ca0b0b', display: 'block', marginTop: 6}}>
                                {urlFieldErrors.firebaseSecureTokenBaseUrl}
                              </small>
                            )}
                          </Form.Group>
                          <Form.Group>
                            <PedidosYaStyle.Text size="12pt">Diario Odoo</PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                              style={fieldStyle}
                              name="odooJournalId"
                              type="number"
                              value={enterpriseCasheaConfig.odooJournalId}
                              disabled={loading || savingEnterpriseConfig}
                              placeholder="Ej: ID del diario BNC Cashea Bs"
                              autoComplete="off"
                              onChange={updateEnterpriseCasheaConfig}
                            />
                          </Form.Group>
                          <Form.Group>
                            <PedidosYaStyle.Text size="12pt">Método de pago Odoo</PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                              style={fieldStyle}
                              name="paymentMethodId"
                              type="number"
                              value={enterpriseCasheaConfig.paymentMethodId}
                              disabled={loading || savingEnterpriseConfig}
                              placeholder="1"
                              autoComplete="off"
                              onChange={updateEnterpriseCasheaConfig}
                            />
                          </Form.Group>
                          <Form.Group>
                            <PedidosYaStyle.Text size="12pt">Término de pago</PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                              style={fieldStyle}
                              name="paymentTerm"
                              type="number"
                              value={enterpriseCasheaConfig.paymentTerm}
                              disabled={loading || savingEnterpriseConfig}
                              placeholder="Ej: ID del término de pago Odoo"
                              autoComplete="off"
                              onChange={updateEnterpriseCasheaConfig}
                            />
                          </Form.Group>
                          <div style={{gridColumn: '1 / -1', display: 'flex', justifyContent: 'center', marginTop: 4}}>
                            <PedidosYaStyle.BtnSend
                              style={{ ...ui.primaryBtn, width: 320 }}
                              disabled={loading || savingEnterpriseConfig}
                              onClick={saveCasheaEnterpriseConfig}
                            >
                              {savingEnterpriseConfig ? 'Guardando...' : 'Guardar configuración global'}
                            </PedidosYaStyle.BtnSend>
                          </div>
                        </div>
                      </div>

                      <div style={ui.sectionCard}>
                        <h4 style={ui.sectionTitle}>Automatización de órdenes de Cashea</h4>
                        <p style={ui.sectionDesc}>
                          Si está activo, se mantiene el flujo automatizado actual. Si está desactivado, todas las órdenes sincronizadas se crean en borrador (presupuesto) sin facturación automática.
                        </p>
                        <Form.Group style={{marginBottom: 16}}>
                          <Form.Check
                            type="checkbox"
                            id="cashea-automation-toggle"
                            name="casheaAutomation"
                            label="Activar flujo automatizado de Cashea"
                            checked={Boolean(enterpriseCasheaConfig.casheaAutomation)}
                            disabled={loading || savingCasheaAutomation || savingEnterpriseConfig}
                            onChange={updateEnterpriseCasheaConfig}
                          />
                        </Form.Group>
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                          <PedidosYaStyle.BtnSend
                            style={{ ...ui.primaryBtn, width: 320 }}
                            disabled={loading || savingCasheaAutomation || savingEnterpriseConfig}
                            onClick={saveCasheaAutomationConfig}
                          >
                            {savingCasheaAutomation ? 'Guardando...' : 'Guardar configuración'}
                          </PedidosYaStyle.BtnSend>
                        </div>
                      </div>

                      <div style={ui.sectionCard}>
                        <h4 style={ui.sectionTitle}>Procesamiento en lotes (Cashea → Odoo)</h4>
                        <p style={ui.sectionDesc}>
                          Controla cómo se sincronizan las órdenes de Cashea hacia Odoo. El modo asíncrono encola las órdenes y las procesa en lotes de forma ordenada y resiliente, reduciendo la carga sobre Odoo. Si no estás seguro, deja estas opciones desactivadas (comportamiento por defecto).
                        </p>
                        <Form.Group style={{marginBottom: 12}}>
                          <Form.Check
                            type="checkbox"
                            id="cashea-batch-create-toggle"
                            name="batchCreateEnabled"
                            label="Creación de órdenes en lote"
                            checked={Boolean(enterpriseCasheaConfig.batchCreateEnabled)}
                            disabled={loading || savingBatchConfig || savingEnterpriseConfig}
                            onChange={updateEnterpriseCasheaConfig}
                          />
                          <small style={ui.sectionDesc}>Agrupa la creación de las sale.order en Odoo. El resto del flujo por orden no cambia.</small>
                        </Form.Group>
                        <Form.Group style={{marginBottom: 12}}>
                          <Form.Check
                            type="checkbox"
                            id="cashea-batch-billing-toggle"
                            name="batchBillingEnabled"
                            label="Facturación en lote"
                            checked={Boolean(enterpriseCasheaConfig.batchBillingEnabled)}
                            disabled={loading || savingBatchConfig || savingEnterpriseConfig || !enterpriseCasheaConfig.batchCreateEnabled}
                            onChange={updateEnterpriseCasheaConfig}
                          />
                          <small style={ui.sectionDesc}>Pre-ejecuta confirmación/factura/pago en lote antes del flujo idempotente por orden. Requiere "Creación de órdenes en lote".</small>
                        </Form.Group>
                        <Form.Group style={{marginBottom: 16}}>
                          <Form.Check
                            type="checkbox"
                            id="cashea-async-queue-toggle"
                            name="asyncQueueEnabled"
                            label="Procesamiento asíncrono por cola"
                            checked={Boolean(enterpriseCasheaConfig.asyncQueueEnabled)}
                            disabled={loading || savingBatchConfig || savingEnterpriseConfig}
                            onChange={updateEnterpriseCasheaConfig}
                          />
                          <small style={ui.sectionDesc}>Encola las órdenes (productor/consumidor) y las sincroniza a Odoo en lotes de forma asíncrona. Recomendado para alto volumen.</small>
                        </Form.Group>
                        <h4 style={{ ...ui.sectionTitle, fontSize: 14 }}>Parámetros de lote</h4>
                        <p style={ui.sectionDesc}>
                          Valores operativos del procesamiento en lotes. El servidor acota cada valor a su rango válido.
                        </p>
                        <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 14, marginBottom: 16}}>
                          <Form.Group>
                            <PedidosYaStyle.Text size="12pt">Órdenes por llamada Odoo</PedidosYaStyle.Text>
                            <Form.Control
                              type="number"
                              name="batchMaxOrdersPerCall"
                              min={1}
                              max={1000}
                              value={enterpriseCasheaConfig.batchMaxOrdersPerCall}
                              disabled={loading || savingBatchConfig || savingEnterpriseConfig}
                              onChange={updateEnterpriseCasheaConfig}
                            />
                            <small style={ui.sectionDesc}>Rango: 1–1000</small>
                          </Form.Group>
                          <Form.Group>
                            <PedidosYaStyle.Text size="12pt">Pagos por llamada Odoo</PedidosYaStyle.Text>
                            <Form.Control
                              type="number"
                              name="batchMaxPaymentsPerCall"
                              min={1}
                              max={1000}
                              value={enterpriseCasheaConfig.batchMaxPaymentsPerCall}
                              disabled={loading || savingBatchConfig || savingEnterpriseConfig}
                              onChange={updateEnterpriseCasheaConfig}
                            />
                            <small style={ui.sectionDesc}>Rango: 1–1000</small>
                          </Form.Group>
                          <Form.Group>
                            <PedidosYaStyle.Text size="12pt">Pausa entre conciliaciones (ms)</PedidosYaStyle.Text>
                            <Form.Control
                              type="number"
                              name="batchReconcileSleepMs"
                              min={0}
                              max={5000}
                              value={enterpriseCasheaConfig.batchReconcileSleepMs}
                              disabled={loading || savingBatchConfig || savingEnterpriseConfig}
                              onChange={updateEnterpriseCasheaConfig}
                            />
                            <small style={ui.sectionDesc}>Rango: 0–5000 ms</small>
                          </Form.Group>
                          <Form.Group>
                            <PedidosYaStyle.Text size="12pt">Lote del consumidor (cola)</PedidosYaStyle.Text>
                            <Form.Control
                              type="number"
                              name="batchConsumerBatchSize"
                              min={1}
                              max={500}
                              value={enterpriseCasheaConfig.batchConsumerBatchSize}
                              disabled={loading || savingBatchConfig || savingEnterpriseConfig}
                              onChange={updateEnterpriseCasheaConfig}
                            />
                            <small style={ui.sectionDesc}>Rango: 1–500</small>
                          </Form.Group>
                          <Form.Group>
                            <PedidosYaStyle.Text size="12pt">Timeout de job colgado (min)</PedidosYaStyle.Text>
                            <Form.Control
                              type="number"
                              name="batchStaleProcessingMinutes"
                              min={5}
                              max={120}
                              value={enterpriseCasheaConfig.batchStaleProcessingMinutes}
                              disabled={loading || savingBatchConfig || savingEnterpriseConfig}
                              onChange={updateEnterpriseCasheaConfig}
                            />
                            <small style={ui.sectionDesc}>Rango: 5–120 min</small>
                          </Form.Group>
                          <Form.Group>
                            <PedidosYaStyle.Text size="12pt">Reintentos máximos por orden</PedidosYaStyle.Text>
                            <Form.Control
                              type="number"
                              name="batchMaxAttempts"
                              min={1}
                              max={10}
                              value={enterpriseCasheaConfig.batchMaxAttempts}
                              disabled={loading || savingBatchConfig || savingEnterpriseConfig}
                              onChange={updateEnterpriseCasheaConfig}
                            />
                            <small style={ui.sectionDesc}>Rango: 1–10</small>
                          </Form.Group>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                          <PedidosYaStyle.BtnSend
                            style={{ ...ui.primaryBtn, width: 320 }}
                            disabled={loading || savingBatchConfig || savingEnterpriseConfig}
                            onClick={saveCasheaBatchConfig}
                          >
                            {savingBatchConfig ? 'Guardando...' : 'Guardar configuración'}
                          </PedidosYaStyle.BtnSend>
                        </div>
                      </div>

                      <h4 style={{ ...ui.sectionTitle, marginBottom: 16 }}>Actualizar Merchant</h4>
                      <div style={{ display: 'grid', gap: 18, alignItems: 'start' }}>
                            <div style={ui.sectionCard}>
                              <h4 style={{ ...ui.sectionTitle, fontSize: 14 }}>Sección 1: Datos del merchant</h4>
                              <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 14, alignItems: 'end'}}>
                                <Form.Group>
                                  <PedidosYaStyle.Text size="12pt">Tarifa</PedidosYaStyle.Text>
                                  <ReactSelect
                                    isSearchable
                                    options={tarifaOptions}
                                    value={selectedTarifaOption}
                                    placeholder="SELECCIONE UNA TARIFA"
                                    noOptionsMessage={() => 'No hay tarifas disponibles'}
                                    onChange={(selected) => changeTarifa(selected?.value || '')}
                                    styles={searchSelectStyles}
                                  />
                                </Form.Group>
                                <Form.Group>
                                  <PedidosYaStyle.Text size="12pt">Merchant</PedidosYaStyle.Text>
                                  <GetMerchants
                                    merchants={listMerchantName}
                                    value={merchantName}
                                    disabled={loading || !hasMerchants}
                                    onChange={(e) => {
                                      changeMerchantName(e);
                                      getMerchant(e)
                                    }}
                                  />
                                </Form.Group>
                                <Form.Group>
                                  <PedidosYaStyle.Text size="12pt">ApiKey oficial</PedidosYaStyle.Text>
                                  <InputGroup>
                                    <PedidosYaStyle.ContIconNadInputPass>
                                      <PedidosYaStyle.Input
                                        style={{width: '100%'}}
                                        name="apiKey"
                                        type={showPass ? 'text' : 'password'}
                                        value={apiKey}
                                        disabled={loading}
                                        placeholder="ApiKey"
                                        autoComplete="off"
                                        onChange={(e) => setApiKey(e.target.value)}
                                      />
                                      <PedidosYaStyle.BtnShowPass onClick={(e) => toggleShowPassword(e)}>
                                        {showPass ? <BiHide /> : <BiShow />}
                                      </PedidosYaStyle.BtnShowPass>
                                    </PedidosYaStyle.ContIconNadInputPass>
                                  </InputGroup>
                                </Form.Group>
                                <div style={{gridColumn: '1 / -1', display:'flex', gap: 18, flexWrap: 'wrap', justifyContent: 'center', marginTop: 10}}>
                                  <PedidosYaStyle.BtnSend style={{ ...ui.primaryBtn, width: 180 }}
                                    onClick={() => {handleMerchant('update', merchantName)}}>
                                    {loading ? "Espere" : "Actualizar"}
                                  </PedidosYaStyle.BtnSend>
                                  <PedidosYaStyle.BtnSend
                                    style={{ ...ui.dangerBtn, width: 180, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    onClick={async() => await handleMerchant('delete', merchantName)}>
                                    {loading ? "Espere" : "Eliminar"}
                                  </PedidosYaStyle.BtnSend>
                                </div>
                              </div>
                            </div>
                            <div style={ui.sectionCard}>
                              <h4 style={{ ...ui.sectionTitle, fontSize: 14 }}>Sección 2: Credenciales Merchant Web Cashea</h4>
                              <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 12, marginBottom: 14}}>
                                <Form.Group>
                                  <PedidosYaStyle.Text size="12pt">Merchant a modificar</PedidosYaStyle.Text>
                                  <GetMerchants
                                    merchants={listMerchantName}
                                    value={credentialsMerchantName}
                                    disabled={loading || !hasMerchants}
                                    onChange={getMerchantCredentials}
                                  />
                                </Form.Group>
                                <Form.Group>
                                  <PedidosYaStyle.Text size="12pt">Employee Role</PedidosYaStyle.Text>
                                  <PedidosYaStyle.Input
                                    style={fieldStyle}
                                    name="employeeRole"
                                    value={merchantWebConfig.employeeRole}
                                    disabled={merchantCredentialInputsDisabled}
                                    placeholder="ADMIN"
                                    autoComplete="off"
                                    onChange={updateMerchantWebConfig}
                                  />
                                </Form.Group>
                              </div>
                              <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 12, marginBottom: 14}}>
                                <Form.Group>
                                  <Form.Check
                                    type="checkbox"
                                    id="cashea-merchant-price-stock-toggle"
                                    name="priceStockEnabled"
                                    label="Actualizar precio y stock"
                                    checked={Boolean(merchantWebConfig.priceStockEnabled)}
                                    disabled={merchantCredentialInputsDisabled}
                                    onChange={(e) => {
                                      // React 16 recicla el evento al salir del handler: el updater
                                      // corre en render y ahi e.target ya es null.
                                      const { checked } = e.target;
                                      setMerchantWebConfig((prev) => ({ ...prev, priceStockEnabled: checked }));
                                    }}
                                  />
                                  <small style={ui.sectionDesc}>Incluye a este merchant en las actualizaciones de precio y stock. La publicación de productos nuevos no se bloquea.</small>
                                </Form.Group>
                                <Form.Group>
                                  <Form.Check
                                    type="checkbox"
                                    id="cashea-merchant-orders-toggle"
                                    name="ordersEnabled"
                                    label="Crear órdenes"
                                    checked={Boolean(merchantWebConfig.ordersEnabled)}
                                    disabled={merchantCredentialInputsDisabled}
                                    onChange={(e) => {
                                      const { checked } = e.target;
                                      setMerchantWebConfig((prev) => ({ ...prev, ordersEnabled: checked }));
                                    }}
                                  />
                                  <small style={ui.sectionDesc}>Incluye a este merchant en la descarga y creación de órdenes (cron síncrono y cola). Apagado ahorra descargas y memoria.</small>
                                </Form.Group>
                              </div>
                              <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 12}}>
                                
                                <div style={{gridColumn: '1 / -1', display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 12}}>
                                  <Form.Group>
                                    <PedidosYaStyle.Text size="12pt">Store ID</PedidosYaStyle.Text>
                                    <PedidosYaStyle.Input
                                      style={fieldStyle}
                                      name="storeId"
                                      type="number"
                                      value={merchantWebConfig.storeId}
                                      disabled={merchantCredentialInputsDisabled}
                                      placeholder="Store ID"
                                      autoComplete="off"
                                      onChange={updateMerchantWebConfig}
                                    />
                                  </Form.Group>
                                  <Form.Group>
                                    <PedidosYaStyle.Text size="12pt">Merchant ID</PedidosYaStyle.Text>
                                    <PedidosYaStyle.Input
                                      style={fieldStyle}
                                      name="merchantId"
                                      type="number"
                                      value={merchantWebConfig.merchantId}
                                      disabled={merchantCredentialInputsDisabled}
                                      placeholder="Merchant ID"
                                      autoComplete="off"
                                      onChange={updateMerchantWebConfig}
                                    />
                                  </Form.Group>
                                  <Form.Group>
                                    <PedidosYaStyle.Text size="12pt">Merchant Group ID</PedidosYaStyle.Text>
                                    <PedidosYaStyle.Input
                                      style={fieldStyle}
                                      name="merchantGroupId"
                                      type="number"
                                      value={merchantWebConfig.merchantGroupId}
                                      disabled={merchantCredentialInputsDisabled}
                                      placeholder="Merchant Group ID"
                                      autoComplete="off"
                                      onChange={updateMerchantWebConfig}
                                    />
                                  </Form.Group>
                                </div>
                                <Form.Group>
                                  <PedidosYaStyle.Text size="12pt">Firebase API Key</PedidosYaStyle.Text>
                                  <PedidosYaStyle.Input
                                    style={fieldStyle}
                                    name="firebaseApiKey"
                                    value={merchantWebConfig.firebaseApiKey}
                                    disabled={merchantCredentialInputsDisabled}
                                    placeholder="Firebase API Key"
                                    autoComplete="off"
                                    onChange={updateMerchantWebConfig}
                                  />
                                </Form.Group>
                                <Form.Group>
                                  <PedidosYaStyle.Text size="12pt">Refresh Token Firebase (AMf)</PedidosYaStyle.Text>
                                  <PedidosYaStyle.Input
                                    style={fieldStyle}
                                    name="firebaseRefreshToken"
                                    type={showPass ? 'text' : 'password'}
                                    value={merchantWebConfig.firebaseRefreshToken}
                                    disabled={merchantCredentialInputsDisabled}
                                    placeholder="AMf..."
                                    autoComplete="off"
                                    onChange={updateMerchantWebConfig}
                                  />
                                </Form.Group>
                                <Form.Group>
                                  <PedidosYaStyle.Text size="12pt">Token</PedidosYaStyle.Text>
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    style={{...fieldStyle, resize: 'vertical'}}
                                    name="tokenRefresh"
                                    value={merchantWebConfig.tokenRefresh}
                                    disabled={merchantCredentialInputsDisabled}
                                    placeholder="Bearer token"
                                    autoComplete="off"
                                    onChange={updateMerchantWebConfig}
                                  />
                                </Form.Group>
                              </div>
                              <div style={{display:'flex', justifyContent: 'center', marginTop: 16}}>
                                <PedidosYaStyle.BtnSend
                                  style={{ ...ui.primaryBtn, width: 240, opacity: (!hasMerchants || !credentialsMerchantName) ? 0.55 : 1 }}
                                  disabled={loading || !hasMerchants || !credentialsMerchantName}
                                  onClick={() => {handleMerchant('updateCredentials', credentialsMerchantName)}}
                                >
                                  {loading ? "Espere" : "Actualizar credenciales"}
                                </PedidosYaStyle.BtnSend>
                              </div>
                              <div style={{borderTop: '1px solid #e7eaf3', marginTop: 18, paddingTop: 16}}>
                                <p style={{ ...ui.sectionDesc, textAlign: 'center', marginBottom: 12 }}>
                                  <strong>Pruebas de endpoints de órdenes</strong>
                                </p>
                                <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 12}}>
                                  {[
                                    {endpoint: 'legacy', label: 'Probar listado de ordenes oficial'},
                                    {endpoint: 'merchant-web-orders', label: 'Probar listado'},
                                    {endpoint: 'order-detail', label: 'Probar detalle'},
                                    {endpoint: 'payment-reference', label: 'Probar referencia de pago'},
                                  ].map((item) => {
                                    const disabled = loading || !!testingEndpoint || !hasMerchants || !credentialsMerchantName;

                                    return (
                                      <PedidosYaStyle.BtnSend
                                        key={item.endpoint}
                                        style={{ ...ui.primaryBtn, minHeight: 42, opacity: disabled ? 0.55 : 1 }}
                                        disabled={disabled}
                                        onClick={() => handleTestOrderEndpoint(item.endpoint)}
                                      >
                                        {testingEndpoint === item.endpoint ? 'Probando...' : item.label}
                                      </PedidosYaStyle.BtnSend>
                                    );
                                  })}
                                </div>
                                <Form.Group style={{marginTop: 12, marginBottom: 0}}>
                                  <PedidosYaStyle.Text size="12pt">UUID de orden (opcional, solo para la referencia de pago)</PedidosYaStyle.Text>
                                  <Form.Control
                                    style={fieldStyle}
                                    name="testOrderUuid"
                                    value={testOrderUuid}
                                    disabled={loading || !!testingEndpoint}
                                    placeholder="Vacío = primera orden pagada del listado"
                                    autoComplete="off"
                                    onChange={(e) => {
                                      const { value } = e.target;
                                      setTestOrderUuid(value);
                                    }}
                                  />
                                </Form.Group>
                              </div>
                            </div>
                            <div style={ui.sectionCard}>
                              <h4 style={{ ...ui.sectionTitle, fontSize: 14 }}>Sección 3: Actualizar token</h4>
                              <div style={{display: 'grid', gridTemplateColumns: '280px 230px', gap: 12, alignItems: 'end', justifyContent: 'center'}}>
                                <Form.Group style={{marginBottom: '0'}}>
                                  <PedidosYaStyle.Text size="12pt">Merchant para actualizar token</PedidosYaStyle.Text>
                                  <GetMerchants
                                    merchants={listMerchantName}
                                    value={tokenMerchantName}
                                    disabled={loading || !hasMerchants}
                                    onChange={getMerchantTokenConfig}
                                    maxWidth="280px"
                                  />
                                </Form.Group>
                                <PedidosYaStyle.BtnSend
                                  style={{ ...ui.primaryBtn, width: '100%', opacity: (!hasMerchants || !tokenMerchantName) ? 0.55 : 1 }}
                                  disabled={loading || !hasMerchants || !tokenMerchantName}
                                  onClick={handleRefreshMerchantToken}
                                >
                                  {loading ? "Espere" : "Actualizar token"}
                                </PedidosYaStyle.BtnSend>
                              </div>
                              <PedidosYaStyle.Text size="11pt" cl="#64748b" style={{display: 'block', textAlign: 'center', marginTop: 12}}>
                                {tokenConfig.tokenUpdatedAt
                                  ? `Última actualización automática: ${new Date(tokenConfig.tokenUpdatedAt).toLocaleString()}`
                                  : 'El token aún no se ha actualizado automáticamente.'}
                              </PedidosYaStyle.Text>
                            </div>
                          </div>
          </PedidosYaStyle.BodyForm>
        </PedidosYaStyle.ContForm>
      </div>
    );
  };

  const productView = () => {
    return (
      <PedidosYaStyle.ContForm style={ui.opsWrap}>
        <PedidosYaStyle.HeaderForm style={ui.opsHeader}>
          <h3 style={ui.opsHeaderTitle}>Operaciones Cashea</h3>
          <p style={ui.opsHeaderSub}>
            Actualiza productos, sincroniza merchants y descarga categorías.
          </p>
        </PedidosYaStyle.HeaderForm>

        <PedidosYaStyle.BodyForm style={ui.opsBody}>
          <div style={ui.sectionCard}>
            <h4 style={ui.sectionTitle}>Sección 1: Actualización de productos</h4>
            <p style={ui.sectionDesc}>
              Envía productos a Cashea de forma individual, por merchant o para todos los merchants configurados.
            </p>
            <div style={ui.opsSectionGrid}>
              <div style={ui.actionCard}>
                <h4 style={ui.actionTitle}>Producto individual</h4>
                <p style={ui.actionDesc}>
                  Ingresa el ID Mongo del producto para enviarlo a Cashea.
                </p>
                <PedidosYaStyle.Input
                  placeholder="Id Mongo del Producto"
                  value={productId}
                  style={ui.input}
                  onChangeCapture={(e) => setProductId(e.target.value)}
                />
                <PedidosYaStyle.BtnSend onClick={() => { handleUpdateProduct('update'); }} style={ui.actionBtn}>
                  {loading ? "Espere" : "Actualizar producto"}
                </PedidosYaStyle.BtnSend>
              </div>

              <div style={ui.actionCard}>
                <h4 style={ui.actionTitle}>Actualización masiva por merchant</h4>
                <p style={ui.actionDesc}>
                  Selecciona un merchant y ejecuta la actualización masiva de productos.
                </p>
                <GetMerchants
                  merchants={listMerchantName}
                  value={merchantName}
                  disabled={loading || !hasMerchants}
                  onChange={(e) => { changeMerchantName(e); }}
                />
                <PedidosYaStyle.BtnSend onClick={() => handleBulkUploadProducts('bulkUpdate')} style={ui.actionBtn}>
                  {loading ? "Espere" : "Actualizar merchant"}
                </PedidosYaStyle.BtnSend>
              </div>

              <div style={ui.actionCard}>
                <h4 style={ui.actionTitle}>Actualizar todos los merchants</h4>
                <p style={ui.actionDesc}>
                  Ejecuta la actualización masiva para todos los merchants configurados.
                </p>
                <PedidosYaStyle.BtnSend
                  onClick={() => handleBulkUploadProducts('bulkUpdate', 'true')}
                  style={ui.actionBtn}
                >
                  {loading ? "Espere" : "Actualizar todo"}
                </PedidosYaStyle.BtnSend>
              </div>
            </div>
          </div>

          <div style={ui.sectionCard}>
            <h4 style={ui.sectionTitle}>Sección 2: Tarifas</h4>
            <p style={ui.sectionDesc}>
              Aplica una lista de precios Odoo a todos los merchants de la empresa.
            </p>
            <div style={ui.opsSectionGrid}>
              <div style={ui.actionCard}>
                <h4 style={ui.actionTitle}>Actualizar todas las tarifas</h4>
                <p style={ui.actionDesc}>
                  Selecciona la tarifa y actualízala en todos los merchants.
                </p>
                <ReactSelect
                  isSearchable
                  options={tarifaOptions}
                  value={selectedTarifaOption}
                  placeholder="SELECCIONE UNA TARIFA"
                  noOptionsMessage={() => 'No hay tarifas disponibles'}
                  onChange={(selected) => changeTarifa(selected?.value || '')}
                  styles={searchSelectStyles}
                />
                <PedidosYaStyle.BtnSend
                  onClick={() => { handleMerchant('uptTarifa', merchantName); }}
                  style={ui.actionBtn}
                >
                  {loading ? "Espere" : "Actualizar tarifas"}
                </PedidosYaStyle.BtnSend>
              </div>
            </div>
          </div>

          <div style={{ ...ui.sectionCard, marginBottom: 0 }}>
            <h4 style={ui.sectionTitle}>Sección 3: Sincronización y catálogo</h4>
            <p style={ui.sectionDesc}>
              Sincroniza merchants con Cashea y descarga el árbol de categorías para publicaciones.
            </p>
            <div style={ui.opsSectionGrid}>
              <div style={ui.actionCard}>
                <h4 style={ui.actionTitle}>Sincronizar merchant individual</h4>
                <p style={ui.actionDesc}>
                  Selecciona un merchant y ejecuta la sincronización en segundo plano.
                </p>
                <GetMerchants
                  merchants={listMerchantName}
                  value={syncMerchant.merchantAdd}
                  name="merchantAdd"
                  disabled={loading || !hasMerchants}
                  onChange={hdlSetSyncMerchants}
                />
                <PedidosYaStyle.BtnSend
                  onClick={async () => { await handleMerchant('sync', syncMerchant); }}
                  style={ui.actionBtn}
                >
                  {loading ? "Espere" : "Sincronizar merchant"}
                </PedidosYaStyle.BtnSend>
              </div>

              <div style={ui.actionCard}>
                <h4 style={ui.actionTitle}>Sincronizar todos los merchants</h4>
                <p style={ui.actionDesc}>
                  Ejecuta la sincronización masiva de todos los merchants configurados en la empresa.
                </p>
                <PedidosYaStyle.BtnSend
                  onClick={() => handleMerchant('sync', 'all')}
                  style={ui.secondaryActionBtn}
                >
                  Sincronizar todos
                </PedidosYaStyle.BtnSend>
              </div>

              <div style={ui.actionCard}>
                <h4 style={ui.actionTitle}>Descargar categorías de Cashea</h4>
                <p style={ui.actionDesc}>
                  Actualiza el árbol de categorías disponible para publicaciones.
                </p>
                <PedidosYaStyle.BtnSend
                  onClick={() => handleMerchant('download-categories')}
                  style={ui.secondaryActionBtn}
                >
                  Descargar categorías
                </PedidosYaStyle.BtnSend>
              </div>
            </div>
          </div>
        </PedidosYaStyle.BodyForm>
      </PedidosYaStyle.ContForm>
    );
  };

  const showedView = () => {
    switch (step) {
      case 0:
        return (
          <Container>
            <Row>
              <div className="d-flex justify-content-center mt-5 pt-5 w-100">
                <h5 style={{ color: "#64748b", fontWeight: 600 }}>Debe seleccionar una empresa.</h5>
              </div>
            </Row>
          </Container>
        );
      case 1:
        return authConfigView();
      case 2:
        return productView();
      default:
        return authConfigView();
    }
  };

  useEffect(() => {
    const hasAccess = verifyAccessRole(Routes, 49);
    if (!hasAccess || globalContext.parentEntId) {
      setRedirect(<Redirect to={`/admin/dashboard`} />);
    }
  }, [globalContext.parentEntId]);

  useEffect(() => {
    if (!globalContext.currentEnterpriseId) {
      setStep(0);
    } else {
      setStep(1);
    }
  }, [globalContext.currentEnterpriseId]);

  return (
    <>
      <OdooStyle>
        {redirect}
        <div className="goBack mt-2" style={{ ...ui.topBar, justifyContent: "flex-start" }}>
          <div style={ui.leftCluster}>
            <Link to="/admin/plugins/my-plugins/my-menu-plugins">
              <button
                type="button"
                className="btn-back"
                style={ui.backBtn(backBtnHovered)}
                aria-label="Volver"
                onMouseEnter={() => setBackBtnHovered(true)}
                onMouseLeave={() => setBackBtnHovered(false)}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
            </Link>

            {step > 0 ? (
              <div style={ui.segmented} role="tablist" aria-label="Sección Cashea">
                <button
                  type="button"
                  role="tab"
                  aria-selected={step === 1}
                  disabled={loading || step === 0}
                  style={ui.segBtn(step === 1, loading || step === 0)}
                  onClick={() => changeStep(1)}
                >
                  Credenciales
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={step === 2}
                  disabled={loading || step === 0}
                  style={ui.segBtn(step === 2, loading || step === 0)}
                  onClick={() => changeStep(2)}
                >
                  Operaciones
                </button>
              </div>
            ) : (
              <p style={{ margin: 0, color: "#64748b", fontSize: "14px" }}>
                Debe seleccionar una empresa
              </p>
            )}
          </div>
        </div>

        <PedidosYaStyle.Header>
          <PedidosYaStyle.Text size="20pt" fw="600" cl="#142032" style={{ textAlign: "center" }} mt="16px" mb="0">
            Cashea Configuración
          </PedidosYaStyle.Text>
        </PedidosYaStyle.Header>

        {showedView()}
      </OdooStyle>
    </>
  );
}
